const BRANDING_STORAGE_KEY = 'superadmin_branding';
const BRANDING_EVENT_NAME = 'superadmin-branding-updated';
const SIGNED_URL_EXPIRY_BUFFER_MS = 30 * 1000;

const parseSignedUrlExpiry = (url) => {
  if (!url || typeof url !== 'string') return null;

  try {
    const parsedUrl = new URL(url);
    const amzDate = parsedUrl.searchParams.get('X-Amz-Date');
    const amzExpires = parsedUrl.searchParams.get('X-Amz-Expires');

    if (amzDate && amzExpires) {
      const match = amzDate.match(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/
      );
      if (!match) return null;

      const [, year, month, day, hour, minute, second] = match;
      const signedAt = Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second)
      );
      return signedAt + Number(amzExpires) * 1000;
    }

    const legacyExpires = parsedUrl.searchParams.get('Expires');
    if (legacyExpires && /^\d+$/.test(legacyExpires)) {
      return Number(legacyExpires) * 1000;
    }
  } catch (_error) {
    return null;
  }

  return null;
};

const normalizeSignedUrl = (url) => {
  const expiresAt = parseSignedUrlExpiry(url);
  if (!expiresAt) return url || null;
  return Date.now() >= expiresAt - SIGNED_URL_EXPIRY_BUFFER_MS ? null : url;
};

export const getFallbackBranding = () => ({
  name: 'LMS',
  logo_url: null,
  favicon_url: null,
});

export const normalizeSuperadminBranding = (branding) => ({
  name: branding?.name || 'LMS',
  logo_url: normalizeSignedUrl(branding?.logo_url || null),
  favicon_url: normalizeSignedUrl(branding?.favicon_url || null),
});

export const getStoredSuperadminBranding = () => {
  try {
    const rawValue = localStorage.getItem(BRANDING_STORAGE_KEY);
    if (!rawValue) return getFallbackBranding();
    return normalizeSuperadminBranding(JSON.parse(rawValue));
  } catch (error) {
    return getFallbackBranding();
  }
};

export const applySuperadminFavicon = (faviconUrl) => {
  if (typeof document === 'undefined') return;

  let faviconLink = document.querySelector("link[rel='icon']");
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.setAttribute('rel', 'icon');
    document.head.appendChild(faviconLink);
  }

  faviconLink.setAttribute('href', faviconUrl || 'data:,');
};

export const persistSuperadminBranding = (branding) => {
  const normalizedBranding = normalizeSuperadminBranding(branding);
  localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(normalizedBranding));
  applySuperadminFavicon(normalizedBranding.favicon_url);
  window.dispatchEvent(
    new CustomEvent(BRANDING_EVENT_NAME, {
      detail: normalizedBranding,
    })
  );
  return normalizedBranding;
};

export const listenForSuperadminBrandingChanges = (callback) => {
  const handler = (event) => {
    callback(normalizeSuperadminBranding(event.detail));
  };

  window.addEventListener(BRANDING_EVENT_NAME, handler);
  return () => window.removeEventListener(BRANDING_EVENT_NAME, handler);
};
